<template>
	<div class="main-dest">
		<!--Test-->
		<Tabs :tabsItems="formTab" @dropdownSelected="dropdownSelection" @mapDragend="formMarker" />
		<button id="tabTest" ref="tabTest" @click="btnClick('tabTest')">Tab Test</button>
	</div>
</template>

<script>
/* eslint-disable */
import GoogleMap from '@/components/GoogleMap.vue';
import EntryPopup from '@/components/EntryPopup.vue';
import Tabs from '@/components/Tabs.vue';

export default {
	components: {
		GoogleMap, EntryPopup, Tabs
	},
	props: {
		//TabMap
		destDraggableMarker: { type: Array, default: function () { return [
			[
				{ position: { lat: 3.08524, lng: 101.57507 }, draggable: true }
			]
		] } },
		testEditGeoFence: { type: Array, default: function () { return [
			{ lat: 3.084393, lng: 101.575722 },
			{ lat: 3.084602, lng: 101.575642 },
			{ lat: 3.084683, lng: 101.575847 },
			{ lat: 3.084471, lng: 101.575933 },
		] } },
		destEditGeoFence: { type: Array, default: function () { return [{"Path": this.testEditGeoFence, "Edit": true}] } },
		//TabMap

		//Form Tab Layout
		formTab: { type: Array, default: function () { return [
			{
				title: "Location", enabled: true, items: [
					[
						[
							{ type: "input", placeholder: "Destination Code", isRequired: true },
							{ type: "input", placeholder: "Destination", isRequired: true },
						],
						{ type: "input", placeholder: "Company", isRequired: true },
						{ type: "input", placeholder: "Address", isRequired: true },
						{ type: "input", placeholder: "Address" },
						{ type: "input", placeholder: "Address" },
						{ type: "input", placeholder: "Address" },
						[
							{ type: "dropdown", placeholder: "Post Code", items: this.postCodeList, itemKey: "PostCode" },
							{ type: "input", placeholder: "City" },
						],
						[
							{ type: "input", placeholder: "State" },
							{ type: "input", placeholder: "Country" },
						],
						[
							{ type: "dropdown", placeholder: "Area", items: this.areaList, itemKey: "AreaCodeName" },
							{ type: "dropdown", placeholder: "Zone Type", items: this.areaList, itemKey: "Type" },
						],
					],
					[
						[
							{ type: "input", placeholder: "Latitude", inputValue: this.formLat },
							{ type: "input", placeholder: "Longitude" },
							{ type: "input", placeholder: "Height" },
						],
						[
							{ type: "checkbox", title: "Geofence" },
							{ type: "button", string: "Add Marker" }
						],
						{ type: "googlemap", marker_list: this.destDraggableMarker, polygon: this.destEditGeoFence },
					]
				]
			},
			{
					title: "Contacts/Details", enabled: true, items: [
							[
									[
											{ type: "dropdown", items: this.destType, placeholder: "Destination Type", isRequired: true },
											{ type: "input", placeholder: "Operations AreaCode" }
									],
									{ type: "input", placeholder: "Contact", isRequired: true },
									[
											{ type: "input", placeholder: "Phone 1", isRequired: true },
											{ type: "input", placeholder: "Phone 2" },

									],
									[
											{ type: "input", placeholder: "Fax" },
											{ type: "input", placeholder: "Fax 2" },
									],
									[
											{ type: "input", placeholder: "E-mail" },
											{ type: "input", placeholder: "E-mail 2" },
									],
									[
											{ type: "dropdown", placeholder: "Required Time", items: this.requiredTime },
											{ type: "input", placeholder: "Custom Time" }
									],
									{ type: "input", placeholder: "Remarks" },
							],
							[
									[
											{ type: "checkbox", title: "Active" },
											{ type: "checkbox", title: "Secured" },
									],
									[
											{ type: "input", placeholder: "Transit" },
											{ type: "input", placeholder: "Container Count" },
									],
									[
											{ type: "input", placeholder: "Average Unstuff Time" },
											{ type: "input", placeholder: "Average Stuff Time" },
									],
									[
											{ type: "input", placeholder: "Office Hours" },
											{ type: "input", placeholder: "Required Time" },
									],
									{type: "remarksbox", title: "Default Remarks"  },
							],
					],
			}
		] } },
	},
	methods: {
		//Button Actions
		btnClick: async function (btn) {
			switch (btn) {
				case 'tabTest':
					console.log("beepboop");
					console.log(this.destCoordList);
					break;
			}
		},
		//Button Actions
	},
	watch: {
	},
	async mounted() {
	}
};
</script>

<style lang="scss" scoped>
.main-dest{
	width: 100%;
	height: 100%;
	padding: 0 50px;
	overflow: hidden;
	display: flex;
	flex-direction: column;
}

.tableButton {
	display: flex;
	flex-direction: row;
	justify-content: flex-end;
	font-size: 10px;
}
</style>